import React from 'react';
import FormFooter from '../raiseQueryForm/FormFooter';

/**
 * EditQueryModalFooter Component
 * Footer for EditQueryModal with cancel and update buttons
 *
 * @param {Function} onClose - Close handler
 * @param {Function} onSubmit - Submit handler
 * @param {boolean} loading - Loading state
 */
const EditQueryModalFooter = ({ onClose, onSubmit, loading }) => (
  <FormFooter
    loading={loading}
    onCancel={onClose}
    onSubmit={onSubmit}
    submitLabel="Update Query"
  />
);

export default EditQueryModalFooter;
